import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { searchStore } from "features/ProductSearch/SearchStore";
import { IconCube, IconDatabaseOff, IconSearchOff } from "@tabler/icons-react";
import clsx from "clsx";
import CustomComponentsEmptyState from "./CustomComponentsEmptyState";
import EmptyStateButtons from "./EmptyStateButtons";
import { COEStore } from "features/ComponentEditor/ComponentEditorStore";

const EmptyState = () => {
  const { t } = useTranslation();

  function getCurrentStateIcon() {
    if (searchStore.selectedTab?.id === "custom_products") {
      return (
        <IconCube className="bg-teal-300 rounded-full p-2 w-16 h-16 mr-2 text-teal-900" />
      );
    }
  }

  function getCurrentStateDescription() {
    if (searchStore.selectedTab?.id === "used_products") {
      if (searchStore.hasAnyFilters()) {
        return t("mapping.emptyStateWithFilterUsedProducts");
      } else {
        return (
          <div className="flex items-center flex-col">
            <IconDatabaseOff className="w-16 h-16 text-gray-200 mb-3" />
            {t("mapping.emptyStateProductWithoutFilterUsedProducts")}
          </div>
        );
      }
    }
    if (searchStore.selectedTab?.type === "PRODUCT") {
      if (searchStore.hasAnyFilters()) {
        return `${t("mapping.emptyStateProductWithFilter")} ${
          !searchStore.selectedTab?.source
            ? t("mapping.emptyStateProductWithFilter2")
            : ""
        }`;
      } else {
        return t("mapping.emptyStateProductWithoutFilter");
      }
    }
    if (
      searchStore.selectedTab?.type === "COMPONENT" &&
      searchStore.hasAnyFilters()
    ) {
      if (
        searchStore.selectedTab.source !== "custom" &&
        !COEStore.openedSearchInCE
      ) {
        return `${t("mapping.emptyStateComponentWithFilter")} ${t(
          "mapping.emptyStateComponentWithFilter2"
        )}. ${t("mapping.emptyStateComponentWithFilter3")}`;
      }
      if (COEStore.openedSearchInCE) {
        return `${t("mapping.emptyStateComponentWithFilter")}.`;
      } else {
        return `${t("mapping.emptyStateComponentWithFilter")} ${t(
          "mapping.emptyStateComponentWithFilter2"
        )}.`;
      }
    } else {
      return "";
    }
  }

  const shouldShowOpenEditorButton = () =>
    searchStore.selectedTab?.id === "custom_components" &&
    !searchStore.hasAnyFilters();

  return (
    <div
      className={clsx(
        "flex flex-col w-full items-center justify-center mt-[155px]",
        {
          "!mt-8":
            shouldShowOpenEditorButton() &&
            !searchStore.searchError &&
            !COEStore.openedSearchInCE,
          "!mt-20": searchStore.selectedTab?.source === "custom",
        }
      )}
    >
      {searchStore.searchError ? (
        <Fragment>
          <IconDatabaseOff className="w-16 h-16 mr-2 text-gray-200" />
          <span className="font-normal text-sm text-gray-500 p-4 max-w-[790px] text-center">
            {t("mapping.serverErrorMsg", {
              item:
                searchStore.selectedTab?.type === "PRODUCT"
                  ? t("mapping.products")
                  : t("mapping.components"),
            })}
          </span>
        </Fragment>
      ) : (
        <Fragment>
          {searchStore.hasAnyFilters() ? (
            <IconSearchOff className="w-16 h-16 mr-2 text-gray-200" />
          ) : (
            getCurrentStateIcon()
          )}
          <span className="font-normal text-sm text-gray-500 p-4 max-w-[790px] text-center">
            {getCurrentStateDescription()}
          </span>
          {shouldShowOpenEditorButton() ? <CustomComponentsEmptyState /> : null}
          <EmptyStateButtons
            enableProductEditorCreation={shouldShowOpenEditorButton()}
          />
        </Fragment>
      )}
    </div>
  );
};

export default observer(EmptyState);
